/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/tarifa'

export default {
    get: params => {
        let customRoute = `${route}?tipo_ciclo_id=${params.cicloID}&expand=campus,seccion,grado,status_description&search=${params.filter}`
        switch (params.tarifaEstado) {
            case "2": customRoute = `${route}?estado=1&tipo_ciclo_id=${params.cicloID}&expand=campus,seccion,grado,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&tipo_ciclo_id=${params.cicloID}&expand=campus,seccion,grado,status_description&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    getAllRecords: () => Api().get(`${route}?fields=id,nombre&expand=campus,seccion,grado,status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=campus,seccion,grado,status_description,history`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=campus,seccion,grado,status_description`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=campus,seccion,grado,status_description`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=campus,seccion,grado,status_description`)
}
